import type { BangKeNhapXuatKhoResponse, BangKeNhapXuatKhoRow } from '@/types/schemas/bang-ke-nhap-xuat-kho.type';
import QUERY_KEYS from '@/constants/query-keys';
import api from '@/lib/api';

export const fetchAllBangKeNhapXuatKho = async (
  entitySlug: string,
  body: object = {},
  pageSize = 50000
): Promise<BangKeNhapXuatKhoRow[]> => {
  const endpoint = `/entities/${entitySlug}/erp/${QUERY_KEYS.BANG_KE_NHAP_XUAT_KHO}/`;
  const fetchPage = (page: number) =>
    api.post<BangKeNhapXuatKhoResponse>(endpoint, body, {
      params: {
        page,
        page_size: pageSize
      }
    });

  const firstResponse = await fetchPage(1);
  const firstPageResults = firstResponse.data.results || [];
  const totalCount = firstResponse.data.count ?? firstPageResults.length;
  const totalPages = Math.ceil(totalCount / pageSize);

  if (totalPages <= 1) {
    return firstPageResults;
  }

  const remainingPageRequests = Array.from({ length: totalPages - 1 }, (_, index) => fetchPage(index + 2));
  const remainingResponses = await Promise.all(remainingPageRequests);
  const remainingResults = remainingResponses.flatMap(response => response.data.results || []);

  return [...firstPageResults, ...remainingResults];
};
